module.exports = __webpack_public_path__ + "fonts/cangqiong.128f3f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/cangqiong.ttf
// module id = TnTn
// module chunks = 74